import { difference, filter, forEach, has, isArray, isString, sortBy } from 'lodash-es';
import moment from 'moment';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import MainButtonSet from '../../components/mainButtonSet';
import OrderStatusBgColor from '../../components/orderStatusBgColor';
import OrderStatusColors from '../../components/orderStatusColors';
import WaitingButton from '../../components/waiting-button/waiting-button.vue';
import Pager from '../../components/pager';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import template from './trackShipmentGuest.vue';
import trackingGuest from '../trackingGuest';
import { analytics } from '../../services/analytics';
function getSearchText(searchText: string | string[]) {
    const splitter = ',';
    const keyWords = new Set<string>([]);
    if (isString(searchText)) {
        forEach(searchText.split(splitter), i => {
            keyWords.add(i.trim());
        });
    }

    if (isArray(searchText)) {
        forEach(searchText, i => {
            forEach(i.split(splitter), j => {
                keyWords.add(j.trim());
            });
        });
    }

    return Array.from(keyWords.values()).join(splitter);
}

@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        Pager,
        OrderStatusColors,
        OrderStatusBgColor,
        WaitingButton,
        trackingGuest,
    },
})
export default class TrackShipmentGuest extends Vue {
    searchInfo: any = '';
    sortBy: any = '';
    recentlyTrackedShipments: Array<any> = [];
    setsessionTrackedShipment: any = {};
    sessionTrackedShipments: Array<any> = [];
    trackingStatusList: Array<any> = [];
    shipmentStatusList: Array<any> = [];
    showErrTip: boolean = false;
    errorText: String = '';
    isSearch: boolean = false;
    paging: any = {};
    company_id: any = {};
    isopenItem: Array<any> = [];
    isOpenOrder: number = -1;
    trackingGuestOrderId: any = '';
    trackShipmentQuerymodle: any = '1';

    closeTips() {
        this.showErrTip = false;
    }

    @Watch('searchInfo')
    getSearchInfo(val: any, oldVal: any) {
        this.chargeTrack(val);
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    created() {}

    mounted() {
        if (this.$route.query && this.$route.query.searchText) {
            this.searchInfo = getSearchText(this.$route.query.searchText);
            this.trackShipment();
        }
    }

    goToLogoIn() {
        window.location.href = '#/';
    }

    onSortby(sortby: any) {
        this.sessionTrackedShipments = sortBy(this.sessionTrackedShipments, [sortby]);
    }

    onChickTrackedShipment(trackedShipment: any) {
        this.setsessionTrackedShipment = trackedShipment;
        // this.fitterSessionShipment();
        this.routerPush();
    }

    private routerPush() {
        this.trackingGuestOrderId = this.setsessionTrackedShipment.order_id;
    }

    trackShipment(page: any = null) {
        this.isSearch = true;
        const searchType = 'shipment_reference';
        const shouldTrackSearch = !page || Number(page) <= 1;
        let url = `/cpv2/tracking/getOrders?search_text=${getSearchText(this.searchInfo || '')}`;
        if (page) url = url + `&page=${page}`;
        if (this.paging.per_page) url = url + `&page_size=${this.paging.per_page}`;
        this.paging = {};
        if (this.$route.query.company_id) url = url + `&company_id=${this.$route.query.company_id}`;
        tmsServiceBackend.get(url).then(
            (res: any) => {
                if (res.data == undefined) {
                    if (shouldTrackSearch) {
                        analytics.trackSearch({
                            searchType,
                            success: false,
                            resultCount: 0,
                            hasSearchTerm: Boolean(this.searchInfo),
                        });
                    }
                    this.isSearch = false;
                    this.sessionTrackedShipments = [];
                } else {
                    if (res.data.status == 0) {
                        if (shouldTrackSearch) {
                            analytics.trackSearch({
                                searchType,
                                success: false,
                                resultCount: 0,
                                hasSearchTerm: Boolean(this.searchInfo),
                            });
                        }
                        this.showErrorFun(res.data.message);
                        this.sessionTrackedShipments = [];
                        this.isSearch = false;
                        this.isOpenOrder = -1;
                        return;
                    }
                    if (has(res.data.data, 'current_page') && isArray(res.data.data.data)) {
                        this.paging = res.data.data;
                        this.sessionTrackedShipments = res.data.data.data;
                        this.isSearch = false;
                        this.trackingStatusList = filter(
                            this.sessionTrackedShipments,
                            'trackingNo'
                        );

                        if (this.trackingStatusList.length > 0) {
                            forEach(this.trackingStatusList, (item: any) => {
                                if (item.statusUpdateTime) {
                                    item.date = moment(item.statusUpdateTime).format('LL');
                                    item.time = moment(item.statusUpdateTime).format('h:mm A');
                                }
                            });
                        }

                        this.shipmentStatusList = difference(
                            this.sessionTrackedShipments,
                            this.trackingStatusList
                        );

                        if (this.sessionTrackedShipments.length == 1) {
                            this.trackingGuestOrderId = this.sessionTrackedShipments[0].order_id;
                        }
                    } else {
                        this.trackingGuestOrderId = '';
                        this.paging = {
                            current_page: 1,
                            last_page: 1,
                            per_page: 10,
                            total: res.data.data.length,
                        };
                        this.sessionTrackedShipments = res.data.data;
                        this.trackingStatusList = filter(
                            this.sessionTrackedShipments,
                            'trackingNo'
                        );
                        this.shipmentStatusList = difference(
                            this.sessionTrackedShipments,
                            this.trackingStatusList
                        );

                        if (this.trackingStatusList.length > 0) {
                            forEach(this.trackingStatusList, (item: any) => {
                                if (item.statusUpdateTime) {
                                    item.date = moment(item.statusUpdateTime).format('LL');
                                    item.time = moment(item.statusUpdateTime).format('h:mm A');
                                }
                            });
                        }

                        this.isSearch = false;

                        if (
                            this.sessionTrackedShipments.length == 1 &&
                            this.sessionTrackedShipments.length === this.trackingStatusList.length
                        ) {
                            localStorage.removeItem('trackingNo');
                            localStorageUtil.setItemToStorage(
                                'trackingNo',
                                this.trackingStatusList[0]
                            );

                            this.trackingGuestOrderId = this.sessionTrackedShipments[0].trackingNo;
                        }
                    }
                    if (shouldTrackSearch) {
                        analytics.trackSearch({
                            searchType,
                            success: true,
                            resultCount: this.sessionTrackedShipments.length,
                            hasSearchTerm: Boolean(this.searchInfo),
                        });
                    }
                }
            },
            (err: any) => {
                if (shouldTrackSearch) {
                    analytics.trackSearch({
                        searchType,
                        success: false,
                        resultCount: 0,
                        hasSearchTerm: Boolean(this.searchInfo),
                    });
                }
                this.isSearch = false;
                this.showErrorFun(err.response.data.statusText);
            }
        );
    }

    onSessionTrackedShipment(item: any) {
        this.setsessionTrackedShipment = item;
        this.routerPush();
    }

    triggerSearchFromPager(item: any) {
        this.paging.per_page = item.pageSize;
        this.trackShipment(item.currentPage);
    }

    onFunIsopen(index: any) {
        if (this.isOpenOrder == index) this.isOpenOrder = -1;
        else this.isOpenOrder = index;
    }

    funIsopenItem(item: any) {
        let orderIdIndex = this.isopenItem.indexOf(item['order_id']);
        if (orderIdIndex > -1) {
            return true;
        } else {
            return false;
        }
    }

    onSessionTrackingNo(item: any) {
        localStorage.removeItem('trackingNo');
        localStorageUtil.setItemToStorage('trackingNo', item);
        this.trackingGuestOrderId = item.trackingNo;
    }

    chargeTrack(searchInfo: any) {
        this.trackingGuestOrderId = '';
        this.searchInfo = searchInfo;
        const fullUrl = window.location.href;
        const hashPart = fullUrl.split('#')[1];
        const searchText = hashPart.split('searchText=')[1];
        const newUrl = fullUrl.replace(searchText, searchInfo);
        window.history.replaceState(null, '', newUrl);
        this.trackShipment(1);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/trackShipmentGuest/index.ts